import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { roleService } from '../../services/roleService';
import { CloseOutlined } from '@ant-design/icons';

const RoleCreateForm = ({ visible, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [descriptionValue, setDescriptionValue] = useState('');
  useEffect(() => {
    if (visible) {
      form.resetFields();
      setDescriptionValue('');
    }
  }, [visible, form]);

  const handleDescriptionChange = (e) => {
    setDescriptionValue(e.target.value);
  };

  const clearDescription = () => {
    form.setFieldsValue({ description: '' });
    setDescriptionValue('');
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      
      // 构造API请求数据
      const roleData = {
        name: values.name,
        code: values.code,
        description: values.description || ''
      };
      
      const response = await roleService.createRole(roleData);
      
      if (response.success) {
        message.success(t('role.createSuccess'));
        onSuccess();
      } else {
        message.error(response.errorMessage || t('role.createFailed'));
      }
    } catch (error) {
      console.error('创建角色失败:', error);
      message.error(error.message || t('role.createFailed'));
    } finally {
      setLoading(false);
    }
  };

  const modalTitle = (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{t('role.createTitle')}</span>
      <CloseOutlined onClick={onCancel} style={{ cursor: 'pointer' }} />
    </div>
  );

  return (
    <Modal
      title={modalTitle}
      open={visible}
      onCancel={onCancel}
      destroyOnClose
      width={600}
      closable={false}
      className="role-create-modal"
      footer={[
        <div key="footer" style={{ textAlign: 'right', padding: '10px 0' }}>
          <button 
            className="submit-button"
            onClick={handleSubmit}
            disabled={loading}
          >
            {t('common.submit')}
          </button>
        </div>
      ]}
    >
      <Form
        form={form}
        layout="vertical"
        style={{ marginTop: '20px' }}
      >
        <Form.Item
          name="name"
          label={<span className="required-label">{t('role.name')}</span>}
          rules={[
            { required: true, message: t('role.nameRequired') },
            {
              pattern: /^[^!@#$%^&*()]+$/,
              message: t('role.nameSpecialCharNotAllowed') || '名称不能包含特殊字符 !@#$%^&*()'
            }
          ]}
        >
          <Input 
            placeholder={t('role.namePlaceholder')} 
            maxLength={50} 
            suffix={
              <CloseOutlined
                onClick={() => form.setFieldsValue({ name: '' })}
                style={{ color: 'rgba(0,0,0,.45)', cursor: 'pointer' }}
              />
            }
          />
        </Form.Item>

        <Form.Item
          name="code"
          label={<span className="required-label">{t('role.code')}</span>}
          rules={[
            { required: true, message: t('role.codeRequired') },
            {
              pattern: /^[^!@#$%^&*()]+$/,
              message: t('role.codeSpecialCharNotAllowed') || '代码不能包含特殊字符 !@#$%^&*()'
            }
          ]}
        >
          <Input 
            placeholder={t('role.codePlaceholder')} 
            maxLength={50} 
            suffix={
              <CloseOutlined
                onClick={() => form.setFieldsValue({ code: '' })}
                style={{ color: 'rgba(0,0,0,.45)', cursor: 'pointer' }}
              />
            }
          />
        </Form.Item>

        <Form.Item
          name="description"
          label={t('role.description')}
          style={{ marginBottom: '30px' }}
        >
          <div className="textarea-container">
            <Input.TextArea 
              placeholder={t('role.descriptionPlaceholder')} 
              maxLength={200} 
              rows={4}
              onChange={handleDescriptionChange}
            />
            {descriptionValue && (
              <CloseOutlined
                className="clear-icon"
                onClick={clearDescription}
              />
            )}
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RoleCreateForm; 